import React, { useState } from 'react'
// import { Modal, StyleSheet, KeyboardAvoidingView } from 'react-native';
import { Modal } from 'antd'
import {Text,Button,View,Row} from '../../Components'
import { Colors } from '../../global'


const AlertComponent = ({visible,setVisible,title,text,textInput,numericInput,list,onPress,yes,no,oneButton, button,button2,loading,defaultValue,valueUpdated,min,max,children}) => {
    const [setting, setSetting] = useState('')
    const [number, setNumber] = useState('')
    const [password, setPassword] = useState('')
    const [passwordError, setPasswordError] = useState('')
    const [hidePassword, setHidePassword] = useState(true)
    const [pickerIdx, setPickerIdx] = useState(0)
    if(defaultValue != undefined && valueUpdated && setting!=defaultValue && number!=defaultValue && password!=defaultValue){
        setSetting(defaultValue)
        setNumber(defaultValue)
        setPassword(defaultValue)
    }
    if(children == undefined) children = <></>
    return (
        <Modal
            closeIcon={null}
            // style={{padding:0}}
            // bodyStyle={{margin:0}}
            // animationType="none"
            // transparent={true}
            // backgroundColor={Colors.black}
            open={visible}
            footer={null}
            // statusBarTranslucent ={true}
            onCancel={() => {
                if(!loading) setVisible(false);
            }}
            onOk={() => {
                if(!loading) setVisible(false);
            }}
            onClick={(event)=>{
                event.stopPropagation();
            }}
        >
            <View style={styles.centeredView} onClick={(event)=>{
                event.stopPropagation();
            }}>
            <View style={styles.modalView}>
                {/* 38 */}
                <View >
                    <Text as="xlarge" weight="bold" color="darkGrey">{title}</Text>
                </View>
                {/* flex={text?3:1} */}
                <View style={{padding:5}}  width='100%'>
                    {text && <Text as="large" weight="medium" color="darkGrey">{text}</Text>}
                    {textInput && textInput !="Password" &&
                    <Row.Setting
                        noBorder = {true}
                        title={textInput}
                        setting={setting}
                        changeSetting={setSetting}
                        // setSetting={(value) => updateSettings({ toolName: value.nativeEvent.text })}
                    />}
                    {numericInput ?
                    <Row.Setting
                        noBorder = {true}
                        title={numericInput}
                        min={min}
                        max={max}
                        numeric={true}
                        setting={number}
                        changeSetting={setNumber}
                        // setSetting={(value) => updateSettings({ toolName: value.nativeEvent.text })}
                    />:<></>}
                    {textInput && textInput =="Password" &&
                    <Row.AuthInput 
                        label="Password" 
                        // icon={passIcon} 
                        value={password} 
                        setValue={setPassword} 
                        error={passwordError} 
                        setError={setPasswordError} 
                        hidden={hidePassword} 
                        setHidden={setHidePassword}/>}
                    
                    {list &&  <Row.Picker 
                        title = "Folder"
                        value={list[pickerIdx]}
                        setValue={
                            (value)=>{
                                console.log('NEW VALUE:',value)
                                console.log('List:',list)
                                console.log('Calculated index:',list.findIndex((item)=>item == value))
                                setPickerIdx(list.findIndex((item)=>item == value))
                                // setPickerList(list)
                            }}
                        values = {list}
                        onPress={(value)=>{
                            // setPickerIdx(value)
                        }}
                    />}
                    {children}
                </View>
                <View style={{display:'flex',height:68, flexDirection : 'row', alignSelf:'center', justifyContent:'space-between', alignItems:'center', width:'100%'}} >
                    {button2?button2:!oneButton?
                    <Button
                        style={styles.button}
                        text={no?"No":"Cancel"}
                        disabled = {loading?loading:false}
                        variant="primary-transparent"
                        onPress={() => {
                            if(loading?false:true){
                                setVisible(false)
                                if(no) no()
                            }
                        }}
                    />:<View style={styles.button}/>}
                    {button?button:
                    <Button
                        style={styles.button}
                        isLoading ={loading?loading:false}
                        text={yes?"Yes":"OK"}
                        variant="primary"
                        onPress={() => {
                            if(yes){
                                yes()
                            }else if(text) onPress()
                            if(textInput && textInput !="Password") onPress(setting)
                            if(numericInput) onPress(number)
                            if(textInput && textInput =="Password") onPress(password)
                            if(list) onPress(list[pickerIdx])
                            if(loading == null) setVisible(false)
                        }}
                    />}
                </View>
            </View>
            </View>
        </Modal>
    );
}
 
const styles = {
    centeredView: {
      display:'flex',
      flex: 1,
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
    },
    modalView: {
      backgroundColor: Colors.white,
    //   borderRadius: 30,
    //   paddingTop: 20,
    //   paddingBottom:16,
    //   paddingLeft:24,
    //   paddingRight:24,
      alignItems: "flex-start",
      width:'100%',
    //   height:260,
      shadowColor: "#000",
      shadowOffset: {
        width: 0,
        height: 2
      },
      shadowOpacity: 0.30,
      shadowRadius: 4,
      elevation: 5
    },
    button: {
        width:"48%",
        // backgroundColor:'green'
    },
    textStyle: {
      color: Colors.white,
      fontWeight: "bold",
      textAlign: "center"
    }
  };

export default AlertComponent